import React from 'react';
import './contact.css';

const Contact = () => {
  return (
   
      <section id="contactContent">
      
        <div className="contentC">
          <p className='connectP'> Got questions? Let's connect!</p>
          <button className='contentButton'>
            <a className='introA' href="mailto:alexis.gonzalez.390@gmail.com">
              Let's connect
            </a>
          </button>
        </div>
       
      </section>

  );
};

export default Contact;

